import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { taxonomyUploadsSearchSchema } from '~/features/taxonomy-studio/utils/taxonomy-search';

const UploadsPage = lazy(() => import('~/features/taxonomy-studio/pages/uploads-page'));

/** Taxonomy Studio — CSV bulk upload with row review. */
export const Route = createFileRoute('/_authenticated/_tenant/taxonomy/uploads')({
  validateSearch: taxonomyUploadsSearchSchema,
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <UploadsPage />
    </Suspense>
  ),
});
